import { useEffect, useState } from "react";

/**
 * One-shot /api/health probe — detects API down or DB unavailable (503).
 */
export function useApiHealth() {
  const [checked, setChecked] = useState(false);
  const [reachable, setReachable] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch("/api/health", {
          method: "GET",
          headers: { Accept: "application/json" },
        });
        if (cancelled) return;
        // 503 = API up but DB down; treat as unreachable for parents
        setReachable(res.ok);
      } catch {
        if (!cancelled) setReachable(false);
      } finally {
        if (!cancelled) setChecked(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { checked, reachable };
}
